import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcFlaskColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1089 13.6662V5.66644H15.8906V13.6662L21.5064 20.1009C21.8243 20.4652 21.9995 20.9324 21.9995 21.4159V22.9991C21.9995 23.5514 21.5518 23.9991 20.9995 23.9991H7.00006C6.44778 23.9991 6.00006 23.5514 6.00006 22.9991V21.4159C6.00006 20.9324 6.17526 20.4652 6.49321 20.1009L12.1089 13.6662Z",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.0905 17.3325H8.90905L6.49321 20.1006C6.17526 20.4649 6.00006 20.9321 6.00006 21.4157V22.9989C6.00006 23.5512 6.44778 23.9989 7.00006 23.9989H20.9995C21.5518 23.9989 21.9995 23.5512 21.9995 22.9989V21.4157C21.9995 20.9321 21.8243 20.4649 21.5064 20.1006L19.0905 17.3325Z",
			fill: "#8C81F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6665 6.16651V4.49994C10.6665 4.2238 10.8904 3.99994 11.1665 3.99994H16.8329C17.1091 3.99994 17.3329 4.2238 17.3329 4.49994V6.16651C17.3329 6.44266 17.1091 6.66651 16.8329 6.66651H11.1665C10.8904 6.66651 10.6665 6.44266 10.6665 6.16651Z",
			fill: "#8C81F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15 8.27997H13.0001V7.71997H15V8.27997ZM14.3333 9.94647H13.0001V9.38647H14.3333V9.94647ZM13.0001 11.9465H15V11.3865H13.0001V11.9465Z",
			fill: "#8C81F7"
		})
	]
});
export default SvgIcFlaskColor;
